module.exports = __webpack_public_path__ + "static/media/soldier.567c1654.png";